import Chip from "@mui/material/Chip";
import { ComponentProps } from "../types";

function Component({ component }: ComponentProps) {
	return (
		<Chip
			key={component.id}
			color={(component.properties["color"] || "default") as "default" | "error" | "primary" | "secondary" | "success" | "info" | "warning"}
			label={component.properties["label"]}
			size={(component.properties?.["size"] || "medium") as "medium" | "small"}
			variant={(component.properties?.["variant"] || "filled") as "filled" | "outlined"}
		/>
	);
}

export default Component;
